// TODO [FR-114]: replace "@sentry/react" with "@sentry/tanstack-start-react"
import * as Sentry from "@sentry/react";

/**
 * SentryService singleton for error tracking and reporting.
 * Ensures only one instance of Sentry is initialized.
 */
class ErrorService {
    private static _instance: ErrorService | undefined = undefined;
    private sentry: ReturnType<typeof Sentry.init>;

    /**
     * Private constructor to enforce singleton pattern.
     * @param router - The router instance for integration
     */
    private constructor() {
        this.sentry = Sentry.init({
            dsn: import.meta.env.VITE_SENTRY_DSN,
            environment: import.meta.env.VITE_ENVIRONMENT,
            // TODO [FR-115]: replace browser integration
            integrations: [Sentry.browserTracingIntegration()],
            tracesSampleRate: 1.0,
        });
    }

    /**
     * Returns the singleton instance of SentryService.
     */
    public static initialize(): void {
        if (!this._instance) {
            this._instance = new this();
        }
    }

    /**
     * Gets the singleton instance of SentryService.
     * Throws an error if the service is not initialized.
     */
    public static get instance(): ErrorService {
        if (!this._instance) {
            throw new Error("SentryService is not initialized. Please call initialize() first.");
        }
        return this._instance;
    }

    /**
     * Captures an error using Sentry.
     * @param error - The error to capture
     */
    public capture(error: unknown) {
        this.sentry?.captureException(error);
    }
}

ErrorService.initialize();
export const error = ErrorService.instance;
export default ErrorService;
